import moment from "moment";
import { printfonts } from "./printfonts";
import pdfMake from "pdfmake/build/pdfmake";
import { getCookie, toTitleCase } from "../../oro-module/commonFunctions";
import { json } from "d3";
pdfMake.vfs = printfonts();


pdfMake.fonts = {
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  },
  Lato: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/lato-font/2.0.0/fonts/lato-normal/lato-normal.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/lato-font/2.0.0/fonts/lato-black/lato-black.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/lato-font/2.0.0/fonts/lato-normal-italic/lato-normal-italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/lato-font/2.0.0/fonts/lato-black-italic/lato-black-italic.ttf'
  },
  Times: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/lato-font/2.0.0/fonts/lato-normal/lato-normal.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/lato-font/2.0.0/fonts/lato-black/lato-black.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/lato-font/2.0.0/fonts/lato-normal-italic/lato-normal-italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/lato-font/2.0.0/fonts/lato-black-italic/lato-black-italic.ttf'
  }
};

function createReportHeader(reportHeader, pageData) {
  for (var key in pageData) {
    reportHeader = reportHeader.replace("$" + key + "$", pageData[key]);
  }
  return reportHeader;
}
const getFilterInfo = (current) => {
  let {
    currentPage,
    pageData,
    formElements, localpage
  } = current.props.parentState;
  if (localpage) {
    currentPage = localpage;
  }
  let { filter } = formElements[currentPage];
  // manually look for following field names
  // branch_code, branch_code_name_displa, product_code, product_code_display, customer_number, customer_fullname_display,  

  return '';
}


function createHeadersForHistoryTable({ statutoryColumns }) {
  let headers = [];
  let headers2 = [];
  let totcol = 0;
  let widths = [];
  let accessors = [];

  statutoryColumns.map((col, i) => {
    if (typeof col.show == "undefined" || col.show == true) {
      let text = col.Header;
      let rowSpan = 1;
      let colSpan;
      (col.columns && col.columns.length > 0)
        ? (colSpan = col.columns.length)
        : ([colSpan, rowSpan] = [1, 1]);


      if (col.columns) {
        let hl2 = totcol - headers2.length;
        [...Array(hl2).keys()].map(h => headers2.push(""));
        col.columns.map(subcol => {
          accessors.push({ field: subcol.accessor, color: subcol.color, fontSize: subcol.fontSize, Header: subcol.Header, type: subcol.type, align: subcol.align, back: subcol.back, fontWeight: subcol.fontWeight, formula: subcol.formula });
          subcol.rwidth ? widths.push(subcol.rwidth) : widths.push("auto");
          headers2.push({
            text: subcol.Header,
            bold: true,
            fontSize: 10,
            style: "tableHeader",
            alignment: "center"
          });
        });
      } else {
        accessors.push({ field: col.accessor, color: col.color, fontSize: col.fontSize, Header: col.Header, type: col.type, align: col.align, fontWeight: col.fontWeight, back: col.back, formula: col.formula });
        col.rwidth ? widths.push(col.rwidth) : widths.push("auto");
      }

      totcol += colSpan;

      headers.push({
        text,
        bold: true,
        fontSize: 10,
        style: "tableHeader",
        colSpan,
        rowSpan,
        alignment: "center"
      });
      [...Array(colSpan - 1).keys()].map(h => headers.push({}));
    }
  });

  let body = [headers];
  let headerRows = 1;
  if (headers2.length != 0) {
    [...Array(headers.length - headers2.length).keys()].map(h =>
      headers2.push({})
    );
    body.push(headers2);
    headerRows = 2;
  }
  return { body, widths, accessors, headerRows };
}


function getHeadersFromColumnDefinitions(
  { statutoryColumns,
    reportData,
    fillerText,
    sentData }
) {

  let { body, headerRows, widths, accessors } = createHeadersForHistoryTable({ statutoryColumns });
  let lastFirst = "";
  reportData.map((record, idx) => {
    let row = [];
    let bolden = false;
    let isGroup = false;
    accessors.map(({ field, Header, formula, type, back, fontSize, color, align, fontWeight }, idx2) => {
      let data = {};
      if (!isGroup) {

        if (record[field]) {
          data["text"] = record[field];
          if (align) { data['alignment'] = align; }
          if (type && type == 'currency') { data['alignment'] = 'right'; }
          if (type && type == 'tick') {
            let orig = record[field + "_original"];
            data['text'] = orig == 1 ? 'YES' : 'NO';
          }


          if (formula) { data["bold"] = true; }
          if (sentData[idx] && sentData[idx].skip_rows) { data["bold"] = true; }
          //

          if (fontWeight) { data['bold'] = (typeof fontWeight == 'function') ? fontWeight(record) : true }
          if (back) {
            data['fillColor'] = (typeof back == 'function') ? back(record) : back;
          }
          if (color) { data['color'] = (typeof color == 'function') ? color(record) : color; }
          data["fontSize"] = fontSize ? ((typeof fontSize == 'function') ? fontSize(record) : fontSize) : 8;
        } else {
          data["text"] = "";
        }
        // if (record.skip_rows && (!accessors[idx2 + 1] || (accessors[idx2 + 1] && record[accessors[idx2 + 1]['field']] == ''))) {
        //   isGroup = true;
        //   data['colSpan'] = accessors.length - idx2;
        // }
        row.push(data);
      }
    });

    if ((idx > 0 && (idx % 20 == 0) && idx < reportData.length - 5) || idx == reportData.length - 1) {
      let dat = [{ text: fillerText, colSpan: accessors.length, color: "gray", fontSize: 10, alignment: "center" }];
      [...Array(accessors.length - 1).keys()].map(h => dat.push({}));
      // check parameter for filler text. If enabled then fill
      // body.push(dat);
    }
    body.push(row);
  });
  console.log({ body })

  return { body, headerRows, widths };
}

const textFromColumns = ({ pageData, history, row }) => {
  let columns = { text: '' };
  let blockStyle = {};
  row.map(col => {
    let fld = {};
    if (col.style) {
      blockStyle = col.style
    }
    else {
      if (!col.source || col.source == 'pageData') {
        if (col.field == 'currency_convert' && !pageData[col.field]) {
          fld['text'] = "Rupees";
        } else if (col.field == 'branch_code' && !pageData[col.field]) {
          fld['text'] = "H.O."
        }
        else if (col.field == 'branch_display' && !pageData[col.field]) {
          fld['text'] = ""
        } else {
          fld['text'] = pageData[col.field];

          if (col.field == 'salary_date' || col.field == 'month' || col.field == 'salary_month') {
            console.log("----PASSED DATE---------")
            console.log(pageData[col.field])
            console.log("---------------------")
            const month = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            let passdmonthanddate = pageData[col.field].split('-')
            let mnt = parseInt(passdmonthanddate[1])
            let year = parseInt(passdmonthanddate[0])
            console.log(pageData[col.field].split('-'))
            fld['text'] = month[mnt] + "-" + year
            console.log(fld['text'])


          }
        }
      }
      else if (col.source == 'history') {
        fld['text'] = history[col.field];
      } else if (col.source == 'fixed') {
        fld['text'] = col.value;
      }

      if (col.type) {
        if (col.type == 'date') {
          fld['text'] = moment(fld['text']).format('DD/MM/YYYY');
        } else if (col.type == 'capital') {
          fld['text'] = fld['text'].toUpperCase();
        }
      }
      columns.text += fld['text'] + " ";
    }
  });
  columns.fontSize = 12;
  columns.alignment = "center";
  for (var key in blockStyle) {
    columns[key] = blockStyle[key];
  }
  return columns;
}

const getFinalData = ({ header, pageData, history }) => {
  let final = [];
  header.map(row => {
    if (row[0] instanceof Array) {
      let final2 = getFinalData({ header: row, pageData, history });
      final.push({ columns: final2 });
    } else {
      let columns = textFromColumns({ pageData, history, row });
      final.push({ columns: [columns] });
    }
  });
  return final;
}

const getPageHeaderForPDFReport = ({ pageData, history }) => {
  // by default show branch & as on date. Otherwise get from pdfprops.
  let header = [
    [{ source: 'history', field: 'reportHeader' }, { source: 'fixed', value: 'As on Date' }, { field: 'as_on_date', type: 'date' }],
    [
      [{ source: 'fixed', value: 'Parent Branch' }, { field: 'branch_code' }, { source: 'fixed', value: '-' }, { field: 'branch_display' }, { style: { alignment: "left", fontSize: 10 } }],
      [{ source: 'fixed', value: 'Amounts in' }, { field: 'currency_convert' }, { style: { alignment: "right", fontSize: 8 } }]
    ]
  ];

  let pdfProps;
  if (!history || !history.pdfProps) {
    pdfProps = { pageSize: "A4", pageOrientation: "portrait" };
  } else {
    pdfProps = history.pdfProps;
  }

  if (pdfProps && pdfProps.header) {
    header = history.pdfProps.header;
  }
  let final = getFinalData({ header, pageData, history })

  return final;
}


const downloadPDF = ({ reportData, statutoryColumns, current, sentData }) => {
  // let reportData = state.sortedData;
  // also get header styles, groupings etc.
  let {
    currentPage,
    pageData,
    fileFolder,
    formElements, localpage
  } = current.props.parentState;
  if (localpage) {
    currentPage = localpage;
  }
  let bankname = getCookie('profile');
  bankname = JSON.parse(bankname)
  bankname = bankname['client_name']



  if (!bankname) {
    bankname = "Administrator";
  }

  let { history, statutoryReport } = formElements[currentPage];
  let { pageSize, pageOrientation } = fileFolder;
  let { reportHeader, pivot } = history;
  let ps = pageSize ? pageSize : "A4";
  let po = pageOrientation ? pageOrientation : "portrait";

  reportHeader = createReportHeader(reportHeader, pageData);
  let { profile } = current.props.parentProps.parentState;
  let { display_name, assigned_branch, session_date, roles, username } = profile;
  display_name = toTitleCase(display_name);
  roles = (roles.map(r => r.role).join(", ")).toUpperCase();
  let qrtext = new Date().getTime() + ", " + `${display_name} (${username}). ${ps} ${po}`;
  let fillerText = reportHeader + " Generated on " + moment().format("DD-MMM-YYYY hh:mm:ss A") + ", " + ` By - ${display_name} (User ID - ${username}, Role - ${roles}), on ` + ps + " in " + po + " mode";

  let filterInfo = getFilterInfo(current);
  let reportInfo = getPageHeaderForPDFReport({ pageData, history });

  let pageWidths = {
    landscape: {
      a1: 2384,
      a2: 1684,
      a3: 1191,
      a4: 842,
      legal: 842
    },
    portrait: {
      a1: 1684,
      a2: 1191,
      a3: 842,
      a4: 595,
      legal: 595
    }
  };
  let pagewidth = pageWidths[po.toLowerCase()][ps.toLowerCase()];
  // Create headers.
  let { body, headerRows, widths } = getHeadersFromColumnDefinitions(
    {
      statutoryColumns,
      reportData,
      fillerText,
      sentData
    }
  );

  let headerVals = [[{
    text: bankname,
    fontSize: 14,
    bold: true,
    // decoration: "underline",
    // decorationStyle: "dashed",
    alignment: "center",
    width: "auto",
    margin: [10, 5, 15, -4]
  }]];
  reportInfo.map(ri => headerVals.push([{ text: ri.columns[0].text, fontSize: 10, alignment: "center", margin: [17, 5, 15, -5] }]))

  headerVals.push([{
    canvas: [{ type: 'line', x1: 30, y1: 10, x2: pagewidth - 10, y2: 10, lineWidth: 0.5 }]
  }])

  var docDefinition = {
    defaultStyle: {
      font: 'Roboto'
    },
    info: {
      title: reportHeader,
      author: `${username} - ${bankname}`,
      subject: fillerText,
      keywords: `${reportHeader}, ${bankname}, ${currentPage}`,
    },
    pageMargins: [20, 80, 40, 40],//[left, top, right, bottom]
    header: function (currentPage, pageCount, pageSize) {
      return headerVals;
    },
    pageSize,
    pageOrientation,
    content: [
      // { text: reportHeader, fontSize: 16, alignment: "left", width: "auto" },
      // reportInfo,
      // 'Report properties in either a table or well spaced text.',
      {
        table: {
          fontSize: 12,
          widths,
          headerRows,
          // keepWithHeaderRows: 1,
          body
        }
        // layout: 'headerLineOnly',
        // layout: {
        //   fillColor: function (i, node) {
        //     return (i % 2 === 0) ? '#CCCCCC' : null;
        //   }
        // }
      },
      // { qr: qrtext, fit: 50, alignment: "right" }
    ],
    // footer: function (currentPage, pageCount, pageSize) {
    //   return [

    //     {
    //       columns: [
    //         {
    //           text: fillerText,
    //           width: "auto",
    //           fontSize: 8,
    //           color: "gray"
    //         }
    //       ]
    //     }
    //   ]
    // },

    footer: function (currentPage, pageCount, pageSize) {
      return [{
        columns: [
          [
            {
              text:
                "Page " +
                currentPage.toString() +
                " of " +
                pageCount,
              alignment: "center",
              fontSize: 10
            }
          ],
          [{ qr: qrtext, fit: 30, alignment: "center" }],
          [
            {
              text: "On " + moment().format("DD-MMM-YYYY hh:mm:ss a"),
              alignment: "center",
              fontSize: 10
            }
          ],
          [
            {
              text: `By - ${display_name} (User ID - ${username}).`,
              alignment: "center",
              fontSize: 10
            },
            {
              text:
                "Made with ORO Framework",
              alignment: "center",
              fontSize: 10,
              color: "gray"
            }
          ]
        ]
      },
      {
        columns: [
          {
            text: fillerText,
            width: "auto",
            fontSize: 10,
            color: "gray"
          }
        ]
      }
      ];
    },

    watermark: {
      opacity: 0.1,
      // text: `The Haryana State Apex Bank Ltd - ${username}`,
      text: `${bankname} - ${username}`,
      color: "gray"
    },
  };
  pdfMake
    .createPdf(docDefinition)
    .download(reportHeader + "_" + ps + "_" + pageOrientation);

}

export { downloadPDF };